import { signOut } from "aws-amplify/auth";
import { clearLocalState, sleep } from "@/js/utilities";
import { clearCachedLists } from "@/js/listCache";
import { monitoringCaptureError } from "@/plugins/monitoring";
import { useOutputsStore } from "@/stores/outputs";
import { useUploadsStore } from "@/stores/uploads";

export const SESSION_PURGE_TIMEOUT_MS = 2000;

async function runPurgeStep(purgeStep: () => unknown): Promise<void> {
	try {
		await purgeStep();
	} catch (error) {
		monitoringCaptureError(error instanceof Error ? error : new Error(String(error)), "End session purge");
	}
}

export async function endSession(): Promise<void> {
	// Local state is gone after this, so the uploads guard must not keep the user here.
	useUploadsStore().bypassUnloadGuard = true;
	// The timeout keeps a stalled IndexedDB from trapping the user on the page.
	await Promise.race([
		Promise.all([
			runPurgeStep(clearLocalState),
			runPurgeStep(clearCachedLists),
			runPurgeStep(() => useOutputsStore().purgeCache()),
		]),
		sleep(SESSION_PURGE_TIMEOUT_MS),
	]);
	window.location.href = "/login";
}

export async function signOutAndEndSession(): Promise<void> {
	try {
		await signOut();
	} catch (error) {
		monitoringCaptureError(error, "User sign out");
	}
	await endSession();
}
